<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="6">
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-input  v-model="queryParam.enterpriseName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别">
                <!--<a-select  :allowClear="true" :options="installTypeMap" v-model="queryParam.installType"></a-select>-->
                <a-select  :allowClear="true" v-model="queryParam.installType" >
                  <a-select-option v-for="item in installTypeMap" :title="item.label" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="金额类型">
                <!--<a-select  :allowClear="true" :options="priceTypeMap" v-model="queryParam.priceType"></a-select>-->
                <a-select  :allowClear="true" v-model="queryParam.priceType" >
                  <a-select-option v-for="item in priceTypeMap" :title="item.label" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="城市等级">
                <!--<a-select  :allowClear="true" :options="cityGradeMap" v-model="queryParam.cityLevel"></a-select>-->
                <a-select  :allowClear="true" v-model="queryParam.cityLevel" >
                  <a-select-option v-for="item in cityGradeMap" :title="item.label" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="区域级别">
                <a-select  :allowClear="true" v-model="queryParam.areaLevel">
                  <a-select-option value="1" title="一级">
                    一级
                  </a-select-option>
                  <a-select-option value="2" title="二级">
                    二级
                  </a-select-option>
                  <a-select-option value="3" title="三级">
                    三级
                  </a-select-option>
                  <a-select-option value="4" title="四级">
                    四级
                  </a-select-option>
                  <a-select-option value="5" title="五级">
                    五级
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="区域地址">
                <!--<a-select  :allowClear="true" :options="provinceMap" v-model="queryParam.provinceId" @change="changeProvince"></a-select>-->
                <a-select :allowClear="true" v-model="queryParam.provinceId" @change="changeProvince">
                  <a-select-option v-for="item in provinceMap" :title="item.label" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item label="">
                <!--<a-select  :allowClear="true" :options="cityMap" v-model="queryParam.cityId" @change="changeCity"></a-select>-->
                <a-select :allowClear="true" v-model="queryParam.cityId" @change="changeCity">
                  <a-select-option v-for="item in cityMap" :title="item.label" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="">
                <!--<a-select  :allowClear="true" :options="areaArr" v-model="queryParam.areaId"></a-select>-->
                <a-select :allowClear="true" v-model="queryParam.areaId" >
                  <a-select-option v-for="item in areaArr" :title="item.label" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="操作人" style="margin-left: 14px">
                <a-input  v-model="queryParam.updateBy"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型">
                <a-select :allowClear="true" v-model="queryParam.timeType">
                  <a-select-option value="effectiveTime">
                    生效时间
                  </a-select-option>
                  <a-select-option value="expireTime">
                    失效时间
                  </a-select-option>
                  <a-select-option value="updateTime">
                    操作时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="">
                <a-range-picker @change="onChangeTime" v-model="queryParam.time" style="width:100%"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="FileExcel" v-if="exportAreaPrice">导出Excel</a-button>
            </a-col>
          </a-row>
          <a-divider/>
          <a-row v-if="addAreaPrice">
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button type="primary" icon="plus" @click="$refs.details.add()">新增</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        rowKey="districtPriceDistrictId"
        :columns="columns"
        :data="loadData"
        style="margin-top: 24px"
        :scroll="{ x: 500 }"
        bordered
      >
      <span slot="action" slot-scope="text, record">
        <a v-if="viewAreaPrice" @click="handleEdit(record.districtPriceId)">查看</a>
        <a-divider v-if="viewAreaPrice && editAreaPrice || viewAreaPrice && deleteAreaPrice" type="vertical" />
        <span v-if="editAreaPrice">
          <a @click="configuration(record.districtPriceId)">配置</a>
          <a-divider type="vertical" />
          <a v-if="record.forbiddenStatus == 1" @click="showState(record.districtPriceId, record.forbiddenStatus)">启用</a>
          <a v-else @click="showState(record.districtPriceId, record.forbiddenStatus)">禁用</a>
        </span>
        <a-divider type="vertical" v-if="editAreaPrice && deleteAreaPrice"/>
        <a v-if="deleteAreaPrice" @click="delDistrictPrice(record.districtPriceId)">删除</a>
      </span>
      </s-table>
      <district-price-modal ref="details" @ok="handleOk" />
      <district-edit-modal ref="edit" @ok="handleOk"/>
    </a-card>
    <no-authority v-if="!queryList"></no-authority>
  </div>

</template>

<script>
import { STable } from '@/components'
import { getDistrictPriceList, delDistrictPrice, disableDistrictPrice, enableDistrictPrice } from '@/api/enterprise/districtPrice'
import { getBasicPriceList } from '@/api/basicdatas/OrderType'
import { getselectAllProvince, getselectCityName, getselectAreaName } from '@/api/enterprise/enterprise'
import { getDictMap } from '../../utils/dict'
import DistrictPriceModal from './modules/DistrictPriceModal'
import DistrictEditModal from './modules/DistrictEditModal'
import NoAuthority from './NoAuthority'
import {selectFindAll} from '@/api/enterprise/enterprise'
import { checkPermission } from '@/utils/permissions'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import store from '@/store'

export default {
  name: 'TableList',
  components: {
    STable,
    DistrictPriceModal,
    DistrictEditModal,
    NoAuthority
  },
  data () {
    return {
      store,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam11: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          width:60,
          align:'center'
        },
        {
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业简称',
          dataIndex: 'enterpriseSimpleName',
          align:'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align:'center',
        },
        {
          title: '金额类型',
          dataIndex: 'priceType',
          align:'center',
        },
        {
          title: '区域金额',
          dataIndex: 'price',
          align:'center',
        },
        {
          title: '金额阈值',
          dataIndex: 'proportion',
          align:'center',
        },
        {
          title: '生效时间',
          dataIndex: 'effectiveTime',
          align:'center',
        },
        {
          title: '操作人',
          dataIndex: 'updateBy',
          align:'center',
        },
        {
          title: '操作时间',
          dataIndex: 'updateTime',
          align:'center',
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      installTypeMap: [],
      priceTypeMap: [],
      cityGradeMap: [],
      provinceMap: [],
      cityMap: [],
      areaArr: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      // addEnable: checkPermission('enterprise:districtPriceDistrict:add'),
      // editEnabel: checkPermission('enterprise:districtPriceDistrict:edit'),
      // removeEnable: checkPermission('enterprise:districtPriceDistrict:remove'),
      queryList: checkPermission('districtPriceList:query:list'),
      deleteAreaPrice: checkPermission('deleteAreaPrice'),
      editAreaPrice: checkPermission('editAreaPrice'),
      addAreaPrice: checkPermission('addAreaPrice'),
      viewAreaPrice: checkPermission('viewAreaPrice'),
      exportAreaPrice: checkPermission('exportAreaPrice'),
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getDistrictPriceList(Object.assign(parameter, this.queryParam))
      },
    }
  },
  filters: {
  },
  async created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    // 金额类型
    this.priceTypeArr = await getBasicPriceList()
    this.priceTypeArr.rows.forEach(price => {
      this.priceTypeMap.push({ value: price.id, label: price.priceName })
    })

    selectFindAll({dictTypes:'install_type,city_grade'}).then(res=>{
    // 安装类别
    this.installTypeArr = res.install_type
    this.installTypeArr.forEach((value, key) => {
      this.installTypeMap.push({ value: value.dictValue, label: value.dictLabel })
    })
    // 城市等级
    this.cityGradeArr = res.city_grade
    this.cityGradeArr.forEach((value, key) => {
      this.cityGradeMap.push({ value: value.dictValue, label: value.dictLabel })
    })

    })
    // 省
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        res.rows.forEach(province => {
          this.provinceMap.push({ value: province.provinceCode, label: province.provinceName })
        })
      }
    })
  },
  methods: {
    // 导出
    FileExcel() {
      var str = process.env.VUE_APP_API_BASE_URL + '/enterprise/districtPrice/export?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
    },
    handleAdd () {
      this.$refs.modal.add()
    },
    handleEdit (record) {
      this.$refs.edit.add(record,0)
    },
    configuration(record){
      this.$refs.edit.add(record,1)
    },
    handleOk () {
      this.$refs.table.refresh()
    },
    changeProvince (e) {
      this.cityMap = []
      this.areaArr = []
      // 市
      this.province = { provinceCode: e }
      getselectCityName(this.province).then(res => {
        if (res.code === 0) {
          res.rows.forEach(city => {
            this.cityMap.push({ value: city.cityCode, label: city.cityName })
          })
        }
      })
    },
    changeCity (e) {
      this.areaArr = []
      // 区
      this.city = { cityCode: e }
      getselectAreaName(this.city).then(res => {
        if (res.code === 0) {
          res.rows.forEach(area => {
            this.areaArr.push({ value: area.areaCode, label: area.areaName })
          })
        }
      })
    },
    async installChange(e){
      this.List = [];
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows;
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    onChangeTime (date) {
      if (date) {
        this.queryParam.timeBegin = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    delDistrictPrice (id) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delDistrictPrice({ 'districtPriceId': id }).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
      });
    },
    showState (districtPriceId, status) {
      if (status === '0') {
        disableDistrictPrice({ 'districtPriceId': districtPriceId }).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (status === '1') {
        enableDistrictPrice({ 'districtPriceId': districtPriceId }).then(res => {
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
    // delByIds (ids) {
    //   deldistrictPriceDistrict({ ids: ids.join(',') }).then(res => {
    //     if (res.code === 0) {
    //       this.$message.success('删除成功')
    //       this.handleOk()
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //     this.selectedRowKeys = []
    //   })
    // }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px !important;}
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }

</style>
